import { TabContext, TabList, TabPanel } from "@mui/lab";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Divider,
  Grid,
  InputLabel,
  Stack,
  Tab,
  Typography,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  CardContent,
  Modal,
  IconButton,
  Checkbox,
  CardActionArea
} from "@mui/material";
import { useState, useEffect, useRef } from "react";
import * as actionType from "../../store/actions";
import StageServiceItemList from "./StageServiceItemList";
import FapView from "./FapView";
import NextSteps from "../../shared/components/NextStep";
import { connect, useSelector } from "react-redux";
//import ConfirmSelection from "./ConfirmSelection";
import MessageModal from "../../shared/components/MessageModal";
import { programBoxName, toUSAFormat } from "../../shared/constants";
import moment from "moment/moment";
// import { useNavigate } from "react-router-dom";

const EstimateCards = (props) => {
  const {
    actions,
    loading,
    estimateCards,
    // stageLoading,
    necessaryLoading,
    // adjustmentLoading,
    // optionalLoading,
    stages,
    necessary,
    optional,
    adjustmentList,
    fapLoading,
    practiceData,
    practiceDatas,
    // notes,
    programLoading,
    // programSelection,
    programSuccess,
    programError,
    profileData,
    fapList,
    practiceInfoData
  } = props;
  const practiceId = localStorage.getItem("practiceId");
  const patientId = localStorage.getItem("patientId");
  const [selectedCard, setSelectedCard] = useState({});
  const [showCardDetails, setShowCardDetails] = useState(false);
  const [tabValue, setTabValue] = useState(
    selectedCard?.treatmentType == "PGT-A Analysis" ? "3" : "1"
  );
  console.log(estimateCards, ">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
  const [cards, setCards] = useState([...estimateCards]);
  const [data, setData] = useState([...estimateCards]);
  console.log(cards, "cards ???????????");
  // console.log(data, "???????????????");
  const [totalEstimate, setTotalEstimate] = useState(0);
  const [totalEstimateMax, setTotalEstimateMax] = useState(0);
  const [selectedProgramPrice, setSelectedProgramPrice] = useState(0);
  const [selectedProgramBox, setSelectedProgramBox] = useState(null);
  const [programName, setProgramName] = useState("");
  const [programNameWithNumber, setProgramNameWithNumber] = useState("");
  const [clearBox, setClearBox] = useState(false);
  const [isFapView, setIsFapView] = useState(false);
  const [selectedProgramId, setSelectedProgramId] = useState(null);
  const [selectedPMId, setSelectedPMId] = useState(null);
  const [confirmModal, setConfirmModal] = useState(false);
  const [refundOptionModal, setRefundOptionModal] = useState(false);
  const [refundCheck, setRefundCheck] = useState(false);
  const [isProceedWithoutPgta, setIsProceedWithoutPgta] = useState(null);
  const [isOptout, setIsOptout] = useState(true);
  const [openConfirmPage, setOpenConfirmPage] = useState(false);
  const caseList = useSelector((state) => state.homeReducer.caseStatusList);
  const topRef = useRef(null);
  const [isMessageModal, setIsMessageModal] = useState(false);
  // const navigate = useNavigate();
  const decodeNotesForDisplay = (notes) => {
    if (notes == null || notes === "") {
      return "";
    }
    if (typeof notes === "string") {
      try {
        return decodeURIComponent(escape(atob(notes)));
      } catch (e) {
        return notes;
      }
    }
    if (typeof notes === "object") {
      try {
        return JSON.stringify(notes);
      } catch (e) {
        return String(notes);
      }
    }
    return String(notes);
  };
  const handleNetworkCall = (item) => {
    let payload = {
      practiceId, // stages
      gdmId: item?.gdmId, // stages
      treatmentPlanId: item.treatmentPlanId, // stages
      estimateId: caseList.finEstimateId,
      estimateTpId: item.finEstimateTpId
    };
    actions.getStages(payload);
    actions.getAdjustments(payload);
    actions.getNecessary(payload);
    actions.getOptional(payload);
    if (
      item.treatmentType.toString().toLowerCase().includes("ivf") ||
      item.treatmentType.toString().toLowerCase().includes("fp")
    ) {
      actions.getFertilityAccessPrograms(payload);
    }
  };
  useEffect(() => {
    actions.getPracticeData({ practiceId });
  }, [practiceId]);
  useEffect(() => {
    if (programSuccess || programError) {
      setIsMessageModal(true);
    }
  }, [programError, programSuccess]);

  useEffect(() => {
    if (estimateCards.length == 0) {
      actions.getEstimateCard({ practiceId, estimateId: caseList && caseList.finEstimateId });
    }
    actions.getProfileData({
      practiceId,
      patientId
    });
    actions.getPracticePGTAData(practiceId);
  }, []);

  useEffect(() => {
    if (cards && cards.length) {
      let item = cards.slice()[0];
      cardClick(item);
    }
  }, []);

  useEffect(() => {
    if (tabValue === "2" || tabValue === "3") {
      topRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [tabValue]);

  useEffect(() => {
    if (necessary.length) {
      let normalPrice = necessary.map(({ tpStage, serviceItems }) => {
        if (!tpStage.range) {
          return serviceItems.map((item) => item.grossPrice).reduce((a, b) => a + b, 0);
        }
      });
      let rangeMinPrice = necessary.map(({ tpStage, serviceItems }) => {
        if (tpStage.range) {
          return serviceItems.map((item) => item.grossPrice)[0];
        }
      });
      let rangeMaxPrice = necessary.map(({ tpStage, serviceItems }) => {
        if (tpStage.range) {
          return serviceItems.map((item) => item.grossPrice)[serviceItems.length - 1];
        }
      });
      const minPrice = rangeMinPrice.filter((item) => item).reduce((a, b) => a + b, 0);
      const maxPrice = rangeMaxPrice.filter((item) => item).reduce((a, b) => a + b, 0);

      if (data && data.treatmentType === "PGT-A Analysis") {
        let originalTpPrice = data && data.originalTpPrice;
        setTotalEstimate(
          originalTpPrice + minPrice + normalPrice.filter((item) => item).reduce((a, b) => a + b, 0)
        );

        setTotalEstimateMax(
          originalTpPrice + maxPrice + normalPrice.filter((item) => item).reduce((a, b) => a + b, 0)
        );
      } else {
        setTotalEstimate(
          data.tpPrice + minPrice + normalPrice.filter((item) => item).reduce((a, b) => a + b, 0)
        );

        setTotalEstimateMax(
          data.tpPrice + maxPrice + normalPrice.filter((item) => item).reduce((a, b) => a + b, 0)
        );
      }

      // setTotalEstimate(
      //   data.tpPrice + minPrice + normalPrice.filter((item) => item).reduce((a, b) => a + b, 0)
      // );
      // setTotalEstimateMax(
      //   data.tpPrice + maxPrice + normalPrice.filter((item) => item).reduce((a, b) => a + b, 0)
      // );
    } else {
      if (data && data.treatmentType === "PGT-A Analysis") {
        let originalTpPrice = data && data.originalTpPrice;
        setTotalEstimate(originalTpPrice);
        setTotalEstimateMax(originalTpPrice);
      } else {
        setTotalEstimate(data.tpPrice);
        setTotalEstimateMax(data.tpPrice);
      }
    }
  }, [necessaryLoading]);

  useEffect(() => {
    if (!Object.keys(practiceInfoData).length) {
      let payload = {
        practiceId
      };
      actions.getPracticeInfoData(payload);
    }
  }, [practiceId]);

  const cardClick = (item) => {
    if (practiceData && practiceData.selectionChoice == "Optout") {
      setIsOptout(true);
    }

    actions.resetCostCoverage();
    setTabValue("1");
    setIsFapView(true);
    // console.log(item,)
    setSelectedCard(item);
    if (item?.treatmentType == "PGT-A Analysis") {
      setTabValue("3");
    } else {
      setTabValue("1");
    }
    setData(item);
    setShowCardDetails(true);
    //setCards(estimateCards);
    setProgramNameWithNumber("");
    setCards((prev) =>
      prev
        ?.slice()
        ?.map((items) =>
          items.finEstimateTpId === item.finEstimateTpId
            ? { ...items, bottom_border: true }
            : { ...items, bottom_border: false }
        )
    );
    handleNetworkCall(item);
    actions.reviewEstimate({
      estimateId: caseList.finEstimateId,
      estimateTpId: item.finEstimateTpId
    });
  };
  const handleTabChange = (event, newValue) => {
    event.preventDefault();
    setTabValue(newValue);

    let newItem =
      newValue == "1" || newValue == "3" ? selectedCard : selectedCard.linkedEstimateTreatmentPlan;
    setData(newItem);
    handleNetworkCall(newItem);
    setIsFapView(true);

    setIsProceedWithoutPgta(isProceedWithoutPgta);
  };
  const getProgramId = (programId, fapCardsStore) => {
    setSelectedProgramBox(programId);

    programId.programs.map((item) => {
      if (item.selected === true && programId.boxName !== programBoxName.PAY_PER_CYCLE) {
        setSelectedProgramId(item.programId);
        setSelectedPMId(item.pmId);

        setSelectedProgramPrice(item.programPrice);
      } else if (programId.boxName == programBoxName.PAY_PER_CYCLE) {
        const oneCycle = "1 cycle";
        if (
          item.programName.toLowerCase() === oneCycle.toLowerCase() &&
          item.noOfCycle === 1 &&
          selectedCard.treatmentType.toString().toLowerCase().includes("ivf")
        ) {
          setSelectedProgramId(item.programId);
          setSelectedPMId(item.pmId);
          let ivfPrice = item.programPrice - fapCardsStore.globalPriceOfFet;
          setSelectedProgramPrice(ivfPrice);
        } else if (
          item.programName.toLowerCase() === oneCycle.toLowerCase() &&
          item.noOfCycle === 1 &&
          selectedCard.treatmentType.toString().toLowerCase().includes("fp")
        ) {
          setSelectedProgramPrice(item.programPrice);
        }
      }
    });
  };
  const boxName = (data) => {
    setProgramName(data.boxName);
    if (data.boxName === programBoxName.PAY_PER_CYCLE) {
      setProgramNameWithNumber("Pay Per Cycle");
    } else {
      let seletedBox =
        data && data.programs && data.programs.filter((pData) => pData.selected === true);

      setProgramNameWithNumber(seletedBox && seletedBox[0] && seletedBox[0].programName);
      if (data.boxName == "Single cycle") {
        setSelectedProgramPrice(data.programs[data.programs.length - 1].programPrice);
      }
    }
  };

  const handleProgramSelect = (prgrm, fapCardsStore) => {
    setProgramNameWithNumber("");
    setSelectedProgramPrice(0);
    getProgramId(prgrm, fapCardsStore);
    boxName(prgrm);

    //handleSelectAndProceed();
    window.scrollTo({ top: 0, left: 0, behaviour: "smooth" });
  };
  useEffect(() => {
    if (programNameWithNumber !== "") {
      handleSelectAndProceed();
    }
  }, [programNameWithNumber]);

  const handleSelectAndProceed = () => {
    //setIsProceedWithoutPgta(null);
    if (selectedCard.linkedEstimateTreatmentPlan != null && tabValue == "1") {
      setTabValue("2");
      setData(selectedCard.linkedEstimateTreatmentPlan);
      setIsFapView(false);
      handleNetworkCall(selectedCard.linkedEstimateTreatmentPlan);
    } else if (
      selectedCard.refundApplicationStatus === "Submitted Need Clinical Review" &&
      selectedCard.treatmentType.toString().toLowerCase().includes("ivf") &&
      data.linkedEstimateTreatmentPlan == null
    ) {
      setRefundOptionModal(true);
      setRefundCheck(false);
    } else if (
      selectedCard.linkedEstimateTreatmentPlan == null ||
      tabValue == "2" ||
      tabValue == "3"
    ) {
      setConfirmModal(true);
    }
    if (
      (practiceData && practiceData.selectionChoice === "Voluntary" && tabValue == "2") ||
      (practiceData && practiceData.selectionChoice === "Voluntary" && tabValue == "3")
    ) {
      setIsProceedWithoutPgta(false);
    }

    if (
      (fapList && fapList.programVisualization && fapList.programVisualization.length <= 0) ||
      !programNameWithNumber
    ) {
      setProgramNameWithNumber("Self Pay");
      setSelectedProgramPrice(selectedCard?.tpPrice);
    }
  };
  const handlePgtaClick = () => {
    setIsProceedWithoutPgta(true);
    setConfirmModal(true);
  };
  const handleCancelClick = () => {
    setIsProceedWithoutPgta(null);
    setIsOptout(true);
    if (tabValue == "2" || tabValue == "3") {
      setTabValue("1");
      setIsFapView(true);
      setData(selectedCard);
    }
    if (tabValue == "1") {
      setClearBox(true);
      setSelectedProgramId(null);
      setSelectedPMId(null);
    }
  };

  const handleConfirm = () => {
    setClearBox(false);
    let cycleName = "";

    if (selectedProgramBox && selectedProgramBox.programs) {
      selectedProgramBox?.programs.map((item) => {
        if (item.selected === true) {
          cycleName = item.programName;
        }
      });
    }

    cycleName = programNameWithNumber === "Self Pay" ? "Single cycle" : cycleName;

    const isPgtaAnalysisStandalone =
      selectedCard.treatmentType === "PGT-A Analysis" && tabValue === "3";
    const finalCycleCost =
      isPgtaAnalysisStandalone && isProceedWithoutPgta ? 0 : selectedProgramPrice;

    let body = {
      programId: selectedProgramId,
      pmId: selectedPMId,
      programName: selectedProgramBox?.boxName || programNameWithNumber,
      cycleName: cycleName || "",
      doNotWantPgtaBundledSelection: isProceedWithoutPgta,
      cycleCost: finalCycleCost,
      selectedEstimateTreatmentPlan: {
        ...selectedCard,
        linkedEstimateTreatmentPlan: isProceedWithoutPgta
          ? null
          : selectedCard.linkedEstimateTreatmentPlan,
        isSelected: 1,
        isReview: 1
      }
    };
    delete body.selectedEstimateTreatmentPlan.bottom_border;
    const payload = {
      practiceId,
      patientId,
      estimateId: caseList.finEstimateId,
      body
    };

    actions.updateProgramSelections(payload);
  };
  const handleChangeRadio = (e) => {
    e.target.value == "Yes" ? setIsProceedWithoutPgta(false) : setIsProceedWithoutPgta(true);
    setIsOptout(false);
  };

  const disableSelectBtn = () => {
    if (isExpired(caseList?.publishedDate, data?.gdmEndDate)) {
      return true;
    }
    if (selectedCard && selectedCard.linkedEstimateTreatmentPlan) {
      return programNameWithNumber === "" || (isOptout && isProceedWithoutPgta == null)
        ? true
        : false;
    }
    if (selectedCard.treatmentType.toString().toLowerCase().includes("ivf") && tabValue == 1) {
      return programName == "" ? true : false;
    }
    if (isOptout && isProceedWithoutPgta == null) {
      return tabValue == 1 ? false : true;
    }

    return false;
  };

  const closeMessageModal = () => {
    setIsMessageModal(false);
    setOpenConfirmPage(true);
    actions.resetMsgs();
    actions.getCaseStatusesData({ practiceId, patientId });
    actions.getEstimateCard({ practiceId, estimateId: caseList.finEstimateId });
  };

  const isBundledSaving = (item) => {
    //For FERTILITY PRESERVATION
    //const patientDetail = patientDetails && patientDetails[0];
    const patientAge = profileData && Math.floor(profileData?.personAge);
    const assure20MinAge = item && item.assure20MinAge;
    const assure20MaxAge = item && item.assure20MaxAge;
    const assure30MinAge = item && item.assure30MinAge;
    const assure30MaxAge = item && item.assure30MaxAge;
    const mcpShowEstimate = item && item.mcpShowEstimate;
    const refundApplicationStatus = item && item.refundApplicationStatus;

    return ["ivf", "fp"].some((val) => {
      const isTypeMatch = item?.treatmentType.toString().toLowerCase().includes(val);
      const hasPrograms =
        (fapList && fapList.programVisualization && fapList.programVisualization.length > 0) || 0;
      if (val === "fp") {
        // Hide bundled savings for FP when application is rejected/withdrawn
        const isRejectedOrWithdrawn =
          refundApplicationStatus === "Rejected Not Medically Appropriate" ||
          refundApplicationStatus === "Rejected Incomplete" ||
          refundApplicationStatus === "Application Withdrawn";
        const isAgeValid =
          (patientAge >= assure20MinAge && patientAge <= assure20MaxAge) ||
          (patientAge >= assure30MinAge && patientAge <= assure30MaxAge);
        return (
          isTypeMatch && hasPrograms && isAgeValid && mcpShowEstimate && !isRejectedOrWithdrawn
        );
      }
      return isTypeMatch && hasPrograms;
    });
  };

  const showRefundApplicationBtton = (cardData) => {
    const patientDetail = cardData;
    const patientAge = patientDetail && Math.floor(profileData?.personAge);

    const donorMinAge = patientDetail && patientDetail.donorMinAge;
    const donorMaxAge = patientDetail && patientDetail.donorMaxAge;
    const nonDonorMinAge = patientDetail && patientDetail.nonDonorMinAge;
    const nonDonorMaxAge = patientDetail && patientDetail.nonDonorMaxAge;
    const primaryQuestionId = patientDetail && patientDetail.questionId; //  Question ID should be  : 2
    const primaryQuestionresponse = patientDetail && patientDetail.responseNo; //yes = 1, No = 2;

    let isButtonVisiable = false;

    if (primaryQuestionId === 2) {
      if (primaryQuestionresponse === 1) {
        // Yes Case
        if (patientAge >= donorMinAge && patientAge <= donorMaxAge) {
          isButtonVisiable = true;
        } else {
          isButtonVisiable = false;
        }
      } else {
        // No Case
        if (patientAge >= nonDonorMinAge && patientAge <= nonDonorMaxAge) {
          isButtonVisiable = true;
        } else {
          isButtonVisiable = false;
        }
      }
    }

    return isButtonVisiable;
  };

  const showFPProgramApplication = (cardData) => {
    const {
      treatmentType = "",
      mcpShowEstimate,
      assure20MinAge = 0,
      assure20MaxAge = 0,
      assure30MinAge = 0,
      assure30MaxAge = 0,
      refundApplicationStatus
      //refundApplicationStatus
    } = cardData ?? {};

    let isShow = true;

    // Condition 3: user has not hidden the option via fapVisibilityData flag
    if (mcpShowEstimate === false && treatmentType.toUpperCase() === "FP") {
      isShow = false;
    }

    const patientAge = Math.floor(profileData?.personAge ?? 0);

    // Condition 2: application must NOT be "Rejected Not Medically Appropriate"
    if (
      treatmentType.toUpperCase() === "FP" &&
      (refundApplicationStatus === "Rejected Not Medically Appropriate" ||
        refundApplicationStatus === "Rejected Incomplete" ||
        refundApplicationStatus === "Application Withdrawn")
    ) {
      isShow = false;
    }

    // Condition 4: age must fall within defined ranges
    const within20s = patientAge >= assure20MinAge && patientAge <= assure20MaxAge;
    const within30s = patientAge >= assure30MinAge && patientAge <= assure30MaxAge;
    if (treatmentType.toUpperCase() === "FP" && !within20s && !within30s) {
      isShow = false;
    }

    return isShow;
  };

  const isExpired = (publishDate, gdmEndDate) => {
    if (!publishDate) return false;

    const published = moment(publishDate);
    if (!published.isValid()) return false;

    // Condition 1: Is estimate 91+ days old?
    const isExpiredPublished = moment().diff(published, "days") >= 91;

    // Condition 2: Was GDM active at publish time but ended now?
    const gdmExpired = gdmEndDate
      ? moment(gdmEndDate).isBefore(moment()) // GDM end date is in the past
      : false;

    return isExpiredPublished && gdmExpired;
  };

  // const isExpired = (publishDate) => {
  //   if (!publishDate) return false;

  //   const parsedDate = moment(publishDate);
  //   if (!parsedDate.isValid()) return false;

  //   return moment().diff(parsedDate, "days") > 90;
  // };

  const getAdjustmentTotal = (adjustmentList, data) => {
    const total =
      adjustmentList
        ?.map((item) => {
          if (item?.category === "G" || item?.category === "LI") {
            return item?.amountType === "A"
              ? -(item?.amount || 0)
              : -Math.round(((item?.amount || 0) / 100) * (data?.originalTpPrice || 0));
          } else {
            return item?.amount || 0;
          }
        })
        ?.reduce((sum, val) => sum + val, 0) || 0;

    const absValue = Math.abs(total).toLocaleString("en-US");
    return total < 0 ? `- $${absValue}` : `$${absValue}`;
  };

  return (
    <Box className="card-section" ref={topRef}>
      {!openConfirmPage && (
        <>
          {" "}
          {loading ? (
            <Stack justifyContent="center" p={5} alignItems="center">
              <CircularProgress size={50} />
            </Stack>
          ) : (
            <Grid container spacing={2}>
              {[...cards]?.slice(0)?.map((item, index) => {
                return (
                  <Grid item xs={12} lg={4} key={index}>
                    <Box className={item.bottom_border ? "border-bottom" : ""}>
                      <span className={item.bottom_border ? "bubble-point" : ""} />
                      <Card
                        variant="outlined"
                        sx={{
                          minHeight: "300px",
                          borderBottomLeftRadius: item.bottom_border ? "0px" : "4px",
                          borderBottomRightRadius: item.bottom_border ? "0px" : "4px"
                        }}>
                        <CardActionArea onClick={() => cardClick(item)}>
                          <Stack direction="row" p={1}>
                            <Typography variant="body2">
                              {item.treatmentPlanName}
                              {item.tpLinkId ? " + PGT-A Analysis" : ""}
                            </Typography>
                          </Stack>
                          <Divider sx={{ background: "#1BA3AD", m: 1, height: "1px" }} />
                          <Card
                            variant="outlined"
                            sx={{
                              minHeight: 220,
                              background: item.bottom_border ? "#f9f9f9" : "",
                              borderBottomLeftRadius: item.bottom_border ? "0px" : "4px",
                              borderBottomRightRadius: item.bottom_border ? "0px" : "4px"
                            }}>
                            <Stack
                              direction="column"
                              minHeight={190}
                              justifyContent="space-between">
                              <Stack direction="column" p={1}>
                                <InputLabel>
                                  {item.treatmentType === "PGT-A Analysis"
                                    ? "Package price"
                                    : "Amount due to Practice"}
                                </InputLabel>
                                <Typography>
                                  {data && data.treatmentType !== "PGT-A Analysis"
                                    ? "$" + item.tpPrice.toLocaleString()
                                    : "$" + item.originalTpPrice.toLocaleString()}
                                  {/* ${item.tpPrice.toLocaleString()}{" "} */}
                                  {item.treatmentType === "PGT-A Analysis"
                                    ? " for the PGT-A Analysis Unlimited Program"
                                    : " per cycle"}
                                </Typography>
                                {isBundledSaving(item) ? (
                                  <Typography>(Bundled savings available)</Typography>
                                ) : null}
                              </Stack>
                              {item.tpLinkId ? (
                                <Stack direction="column" p={1}>
                                  <InputLabel>
                                    {item.linkedEstimateTreatmentPlan.treatmentType ===
                                    "PGT-A Analysis"
                                      ? "Package price"
                                      : "Amount due to Practice"}
                                  </InputLabel>
                                  {/* <InputLabel>Services</InputLabel> */}
                                  {/* <Typography>
                                {item.linkedEstimateTreatmentPlan.treatmentPlanName}
                              </Typography> */}
                                  <Typography>
                                    ${item.linkedEstimateTreatmentPlan.tpPrice.toLocaleString()}{" "}
                                    {item.linkedEstimateTreatmentPlan.treatmentType ===
                                    "PGT-A Analysis"
                                      ? " for the PGT-A Analysis Unlimited Program"
                                      : " per cycle"}
                                  </Typography>
                                </Stack>
                              ) : null}
                              <Stack justifyContent="space-around" className="pad-10">
                                {item?.treatmentType?.toUpperCase() === "IVF" &&
                                  fapList?.programVisualization?.length > 0 &&
                                  showRefundApplicationBtton(item) && (
                                    <Typography variant="body2">
                                      {item.mcpShowEstimate &&
                                        item.refundApplicationStatus !==
                                          "Rejected Not Medically Appropriate" &&
                                        item.refundApplicationStatus !== null && (
                                          <>REFUND APPLICATION: {item.refundApplicationStatus}</>
                                        )}
                                    </Typography>
                                  )}
                                {item && item.treatmentType.toUpperCase() === "FP" && (
                                  <Typography variant="body2">
                                    {item.mcpShowEstimate &&
                                      item.refundApplicationStatus !==
                                        "Rejected Not Medically Appropriate" &&
                                      item.refundApplicationStatus !== null && (
                                        <>
                                          ASSURE APPLICATION:{" "}
                                          {item.refundApplicationStatus == null
                                            ? "Incomplete"
                                            : item.refundApplicationStatus}
                                        </>
                                      )}
                                  </Typography>
                                )}
                              </Stack>
                            </Stack>
                            {isExpired(caseList?.publishedDate, data?.gdmEndDate) && (
                              <Typography
                                variant="body2"
                                sx={{
                                  color: "red",
                                  textAlign: "center",
                                  mt: 2,
                                  mb: 2,
                                  px: 1
                                }}>
                                This estimate has expired. Please contact your financial counselor
                                at{" "}
                                {(practiceInfoData &&
                                  practiceInfoData.phoneNumber &&
                                  toUSAFormat(practiceInfoData.phoneNumber)) ||
                                  ""}{" "}
                                to receive a new estimate.
                              </Typography>
                            )}

                            {/* <Divider sx={{ m: 1, height: "1px" }} /> */}
                            {/* <Button
                        variant="outlined"
                        component="span"
                        onClick={(e) => {
                          e.preventDefault();
                          cardClick(item);
                        }}
                        sx={{ my: 1, ml: 1, width: "fit-content" }}>
                        Review Details
                      </Button> */}
                          </Card>
                        </CardActionArea>
                      </Card>
                    </Box>
                  </Grid>
                );
              })}
            </Grid>
          )}
          {showCardDetails ? (
            <Box flexDirection="row" className="p-1" mt={2}>
              {practiceData?.selectionChoice?.toLowerCase() === "pgta with mcp only" &&
                data?.treatmentType == "PGT-A Analysis" &&
                programNameWithNumber === "Pay Per Cycle" && (
                  <div
                    style={{
                      marginBottom: "16px",
                      padding: "12px",
                      backgroundColor: "#e3f2fd",
                      border: "1px solid #2196f3",
                      borderRadius: "4px"
                    }}>
                    The PGT-A Program is only available to patients who enroll in a Fertility Access
                    multi-cycle program. Since you have selected to pay as you go for each cycle,
                    the PGT-A is not available.
                  </div>
                )}
              <TabContext value={tabValue}>
                <Box>
                  <TabList onChange={handleTabChange} className="primary-one">
                    {selectedCard?.treatmentType != "PGT-A Analysis" && (
                      <Tab label={selectedCard.treatmentPlanName} value="1" />
                    )}
                    {selectedCard.tpLinkId ? (
                      practiceData && practiceData.selectionChoice !== "NA" ? (
                        <Tab
                          label={selectedCard.linkedEstimateTreatmentPlan.treatmentPlanName}
                          value="2"
                        />
                      ) : null
                    ) : null}

                    {selectedCard?.treatmentType == "PGT-A Analysis" && !selectedCard.tpLinkId ? (
                      practiceData && practiceData.selectionChoice !== "NA" ? (
                        <Tab label={selectedCard?.treatmentPlanName} value="3" />
                      ) : null
                    ) : null}
                  </TabList>
                </Box>
                <TabPanel value="1" className="p-0">
                  {necessaryLoading ? (
                    <Stack justifyContent="center" p={5} alignItems="center">
                      <CircularProgress size={50} />
                    </Stack>
                  ) : (
                    <>
                      <Card className="p-4 mt-8" variant="outlined">
                        <CardContent className="remove-bottom-padding">
                          <Stack direction="row" justifyContent="space-between">
                            <Typography variant="body2">Treatment Plan</Typography>
                          </Stack>
                          <Divider className="h-divider" />
                          <Stack>
                            {/* <InputLabel>Plan Name</InputLabel> */}
                            <Typography variant="body2">{data.treatmentPlanName}</Typography>
                          </Stack>
                        </CardContent>
                      </Card>
                      {/* Notes Section Started */}
                      <Card className="p-4 mt-8" variant="outlined">
                        <CardContent className="remove-bottom-padding">
                          <Stack direction="row" justifyContent="space-between">
                            <Typography variant="body2">Notes</Typography>
                          </Stack>
                          <Divider className="h-divider" />
                          <Stack>
                            {/* <InputLabel>Plan Name</InputLabel> */}
                            <Typography variant="body2">
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: decodeNotesForDisplay(data.notes)
                                }}
                              />
                            </Typography>
                          </Stack>
                        </CardContent>
                      </Card>

                      <Card className="p-4 mt-8" variant="outlined">
                        <CardContent className="remove-bottom-padding">
                          <Stack direction="row" justifyContent="space-between">
                            <Typography variant="body2">Cost</Typography>
                          </Stack>
                          <Divider className="h-divider" />
                          <Grid container>
                            <Grid item xs={10} sm={8} md={6}>
                              <Stack>
                                <InputLabel>Services</InputLabel>
                                <Typography variant="body2">{data.treatmentPlanName}</Typography>
                              </Stack>
                            </Grid>
                            <Grid item xs={2} sm={4} md={6}>
                              <Stack>
                                <InputLabel>Cost</InputLabel>
                                <Typography variant="body2">
                                  ${data.originalTpPrice.toLocaleString()}
                                </Typography>
                              </Stack>
                            </Grid>
                          </Grid>

                          <Stack className="mt-8 ">
                            {stages.length && data?.treatmentType != "PGT-A Analysis"
                              ? stages.map((item, index) => {
                                  return <Typography key={index}>{item.stageName}</Typography>;
                                })
                              : null}
                          </Stack>
                          {adjustmentList.length &&
                          data &&
                          data.treatmentType !== "PGT-A Analysis" ? (
                            <>
                              <Stack py={1}>
                                <Typography variant="body2">Adjustments</Typography>
                              </Stack>
                              {adjustmentList.map((item, i) => {
                                return (
                                  <Grid container key={i}>
                                    <Grid item xs={10} sm={8} md={6}>
                                      <Stack>
                                        <Typography>
                                          {item.type + (item?.comment ? " - " + item.comment : "")}
                                          {/* {item.type === "Other Cost" || item.type === "Other"
                                            ? item.type + " - " + item?.comment
                                            : item.type} */}
                                        </Typography>
                                      </Stack>
                                    </Grid>
                                    <Grid item xs={2} sm={4} md={6}>
                                      <Stack width="100px" justifyContent="end">
                                        <Typography>
                                          {item.category === "G" || item.category === "LI"
                                            ? item.amountType == "A"
                                              ? ` - $${item.amount.toLocaleString()}`
                                              : ` - $${Math.round(
                                                  (item.amount / 100) * data.originalTpPrice
                                                ).toLocaleString()}`
                                            : `+ $${item.amount.toLocaleString()}`}
                                        </Typography>
                                      </Stack>
                                    </Grid>
                                  </Grid>
                                );
                              })}
                            </>
                          ) : null}

                          <Grid container className="add-to-practice">
                            <Grid item xs={10} sm={8} md={6}>
                              <Typography variant="body2">
                                {data && data.treatmentType === "PGT-A Analysis"
                                  ? "Total Cost of Program"
                                  : data && data.treatmentType && data.treatmentType === "IVF"
                                  ? "Cost per Cycle"
                                  : "Cost per Cycle"}
                              </Typography>
                            </Grid>
                            <Grid item xs={2} sm={4} md={6}>
                              <Typography variant="body2">
                                {data && data.treatmentType === "PGT-A Analysis"
                                  ? "$" + data.originalTpPrice.toLocaleString()
                                  : "$" + data.originalTpPrice.toLocaleString()}
                                {/* ${data.tpPrice.toLocaleString()} */}
                              </Typography>
                            </Grid>
                          </Grid>
                          {data &&
                            data.treatmentType &&
                            data.treatmentType !== "PGT-A Analysis" &&
                            adjustmentList.length > 0 && (
                              <>
                                <Grid container sx={{ backgroundColor: "#f9f9f9" }}>
                                  <Grid item xs={10} sm={8} md={6}>
                                    <Typography variant="body2">
                                      {((adjustmentList?.[0]?.category === "G" ||
                                        adjustmentList?.[0]?.category === "LI") &&
                                        adjustmentList?.[0]?.amountType === "A") ||
                                      adjustmentList?.[0]?.amountType === "P"
                                        ? "Discount"
                                        : "Additional Cost"}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={2} sm={4} md={6}>
                                    <Typography variant="body2">
                                      {getAdjustmentTotal(adjustmentList, data)}
                                      {/* {"$" +
                                        adjustmentList.reduce(
                                          (sum, item) => sum + (item.amount || 0),
                                          0
                                        )} */}
                                    </Typography>
                                  </Grid>
                                </Grid>
                                <Grid container className="add-to-practice">
                                  <Grid item xs={10} sm={8} md={6}>
                                    <Typography variant="body2">Total Due</Typography>
                                  </Grid>
                                  <Grid item xs={2} sm={4} md={6}>
                                    <Typography variant="body2">
                                      ${data.tpPrice.toLocaleString()}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </>
                            )}
                          <Box className="mt-8">
                            <Typography variant="body2">Not Included But Necessary</Typography>
                            {/* data?.treatmentType != "PGT-A Analysis" */}

                            {necessary.length ? <StageServiceItemList data={necessary} /> : null}
                          </Box>
                          <Divider className="mt-8" />
                          <Grid container className="add-to-practice">
                            <Grid item xs={10} sm={8} md={6}>
                              <Typography variant="body2">
                                {data && data.treatmentType && data.treatmentType === "IVF"
                                  ? "Total Estimated Cost per Cycle"
                                  : "Total Estimated Costs*"}
                              </Typography>
                              <Typography
                                variant="caption"
                                style={{ lineHeight: "15px", display: "block", padding: "3px" }}>
                                (Reflects only necessary services and includes costs due outside of
                                the practice)
                              </Typography>
                            </Grid>
                            <Grid item xs={2} sm={4} md={6}>
                              {tabValue == "1" ? (
                                <Typography variant="body2">
                                  ${totalEstimate && totalEstimate.toLocaleString()}
                                  {necessary?.some((item) => item.tpStage.range === true) > 0
                                    ? " - $" +
                                      (totalEstimateMax && totalEstimateMax.toLocaleString())
                                    : ""}
                                </Typography>
                              ) : (
                                <Typography>${data.tpPrice.toLocaleString()}</Typography>
                              )}
                            </Grid>
                          </Grid>
                          {data && data.depositeType === "Partial In Advance" ? (
                            <>
                              <Divider className="mt-8" />
                              <Grid container className="add-to-practice">
                                <Grid item xs={10} sm={8} md={6}>
                                  <Typography variant="body2">
                                    Deposit Due to Begin Treatment
                                    <Typography variant="caption" pl={1}>
                                      {data.depositeComment ?? ""}
                                    </Typography>
                                  </Typography>
                                </Grid>
                                <Grid item xs={2} sm={4} md={6}>
                                  <Typography variant="body2">
                                    ${data.depositeAmount && data.depositeAmount.toLocaleString()}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </>
                          ) : null}
                          <Box className="p-4 mt-8">
                            <Typography variant="body2">
                              Not Included But May Become Necessary
                            </Typography>
                            {optional.length && <StageServiceItemList data={optional} />}
                          </Box>
                        </CardContent>
                      </Card>
                    </>
                  )}
                </TabPanel>
                <TabPanel value="2" className="p-0">
                  {necessaryLoading ? (
                    <Stack justifyContent="center" p={5} alignItems="center">
                      <CircularProgress size={50} />
                    </Stack>
                  ) : (
                    <>
                      <Card className="p-4 mt-8" variant="outlined">
                        <CardContent className="remove-bottom-padding">
                          <Stack direction="row" justifyContent="space-between">
                            <Typography variant="body2">Treatment Plan</Typography>
                          </Stack>
                          <Divider className="h-divider" />
                          <Stack>
                            {/* <InputLabel>Plan Name</InputLabel> */}
                            <Typography variant="body2">{data.treatmentPlanName}</Typography>
                          </Stack>
                        </CardContent>
                      </Card>
                      {(practiceData && practiceData.selectionChoice == "Optout") ||
                      (practiceDatas?.pgtaSelectionChoice?.toLowerCase() == "pgta with mcp only" &&
                        tabValue == "2") ? (
                        <Card className="p-4 mt-8" variant="outlined">
                          <CardContent className="remove-bottom-padding">
                            <Stack direction="row" justifyContent="space-between">
                              <Typography variant="body2">Program Selection</Typography>
                            </Stack>
                            <Divider className="h-divider" />
                            <Stack direction="row">
                              <FormControl>
                                <FormLabel>Select a PGT-A Analysis payment option:</FormLabel>
                                <RadioGroup name="pgtaQuestion" onChange={handleChangeRadio}>
                                  <Stack direction={{ xs: "column", sm: "row" }}>
                                    <FormControlLabel
                                      checked={isProceedWithoutPgta === false ? true : false}
                                      value="Yes"
                                      control={<Radio />}
                                      label="PGT-A Analysis Unlimited Program that offers bundled savings and includes all PGT-A testing until a live birth occurs"
                                      disabled={
                                        practiceDatas?.pgtaSelectionChoice?.toLowerCase() ==
                                          "pgta with mcp only" &&
                                        programNameWithNumber === "Pay Per Cycle"
                                      }
                                    />
                                    <FormControlLabel
                                      checked={
                                        isProceedWithoutPgta === true ||
                                        (practiceDatas?.pgtaSelectionChoice?.toLowerCase() ==
                                          "pgta with mcp only" &&
                                          programNameWithNumber === "Pay Per Cycle")
                                          ? true
                                          : false
                                      }
                                      value="No"
                                      control={<Radio />}
                                      label="I do not want to bundle the cost of PGT-A.  I will pay the genetic lab directly per embryo tested."
                                    />
                                  </Stack>
                                </RadioGroup>
                              </FormControl>
                            </Stack>
                          </CardContent>
                        </Card>
                      ) : null}
                      <Card className="p-4 mt-8" variant="outlined">
                        <CardContent className="remove-bottom-padding">
                          <Stack direction="row" justifyContent="space-between">
                            <Typography variant="body2">Cost</Typography>
                          </Stack>
                          <Divider className="h-divider" />
                          <Grid container>
                            <Grid item xs={10} sm={8} md={6}>
                              <Stack>
                                <InputLabel>Services</InputLabel>
                                <Typography variant="body2">{data.treatmentPlanName}</Typography>
                              </Stack>
                            </Grid>
                            <Grid item xs={2} sm={4} md={6}>
                              <Stack>
                                <InputLabel>Cost</InputLabel>
                                <Typography variant="body2">
                                  ${data.originalTpPrice.toLocaleString()}
                                </Typography>
                              </Stack>
                            </Grid>
                          </Grid>

                          <Stack className="mt-8 ">
                            {stages.length && data?.treatmentType != "PGT-A Analysis"
                              ? stages.map((item, index) => {
                                  return <Typography key={index}>{item.stageName}</Typography>;
                                })
                              : null}
                          </Stack>
                          {adjustmentList.length &&
                          data &&
                          data.treatmentType !== "PGT-A Analysis" ? (
                            <>
                              <Stack py={1}>
                                <Typography variant="body2">Adjustments</Typography>
                              </Stack>
                              {adjustmentList.map((item, i) => {
                                return (
                                  <Grid container key={i}>
                                    <Grid item xs={10} sm={8} md={6}>
                                      <Stack>
                                        <Typography>{item.type} Discount</Typography>
                                      </Stack>
                                    </Grid>
                                    <Grid item xs={2} sm={4} md={6}>
                                      <Stack width="100px" justifyContent="end">
                                        <Typography>
                                          {item.category === "G" || item.category === "LI"
                                            ? item.amountType == "A"
                                              ? ` - $${item.amount.toLocaleString()}`
                                              : ` - $${(
                                                  (item.amount / 100) *
                                                  data.originalTpPrice
                                                ).toLocaleString()}`
                                            : `+ $${item.amount.toLocaleString()}`}
                                        </Typography>
                                      </Stack>
                                    </Grid>
                                  </Grid>
                                );
                              })}
                            </>
                          ) : null}

                          <Grid container className="add-to-practice">
                            <Grid item xs={10} sm={8} md={6}>
                              <Typography variant="body2">
                                {data?.treatmentType === "PGT-A Analysis"
                                  ? "Total Cost of Program"
                                  : "Amount Due to Practice"}
                              </Typography>
                            </Grid>
                            <Grid item xs={2} sm={4} md={6}>
                              <Typography variant="body2">
                                {data && data.treatmentType === "PGT-A Analysis"
                                  ? "$" + data.originalTpPrice.toLocaleString()
                                  : "$" + data.tpPrice.toLocaleString()}
                                {/* ${data.tpPrice.toLocaleString()} */}
                              </Typography>
                            </Grid>
                          </Grid>
                          <Box className="mt-8">
                            <Typography variant="body2">Not Included But Necessary</Typography>
                            {necessary.length && data?.treatmentType != "PGT-A Analysis" ? (
                              <StageServiceItemList data={necessary} />
                            ) : null}
                          </Box>
                          <Divider className="mt-8" />
                          <Grid container className="add-to-practice">
                            <Grid item xs={10} sm={8} md={6}>
                              <Typography variant="body2">Total Estimated Costs*</Typography>
                              <Typography variant="caption">
                                (Reflects only necessary services and includes costs due outside of
                                the practice)
                              </Typography>
                            </Grid>
                            <Grid item xs={2} sm={4} md={6}>
                              {tabValue == "1" ? (
                                <Typography variant="body2">
                                  ${totalEstimate && totalEstimate.toLocaleString()}
                                  {necessary?.some((item) => item.tpStage.range === true) > 0
                                    ? " - $" +
                                      (totalEstimateMax ? totalEstimateMax.toLocaleString() : "")
                                    : ""}
                                </Typography>
                              ) : (
                                <Typography>${data.tpPrice.toLocaleString()}</Typography>
                              )}
                            </Grid>
                          </Grid>

                          <Box className="p-4 mt-8">
                            <Typography variant="body2">
                              Not Included But May Become Necessary
                            </Typography>
                            {optional.length && <StageServiceItemList data={optional} />}
                          </Box>
                        </CardContent>
                      </Card>
                    </>
                  )}
                </TabPanel>

                <TabPanel value="3" className="p-0">
                  {necessaryLoading ? (
                    <Stack justifyContent="center" p={5} alignItems="center">
                      <CircularProgress size={50} />
                    </Stack>
                  ) : (
                    <>
                      <Card className="p-4 mt-8" variant="outlined">
                        <CardContent className="remove-bottom-padding">
                          <Stack direction="row" justifyContent="space-between">
                            <Typography variant="body2">Treatment Plan</Typography>
                          </Stack>
                          <Divider className="h-divider" />
                          <Stack>
                            {/* <InputLabel>Plan Name</InputLabel> */}
                            <Typography variant="body2">{data?.treatmentPlanName}</Typography>
                          </Stack>
                        </CardContent>
                      </Card>
                      {(practiceData && practiceData.selectionChoice == "Optout") ||
                      (practiceDatas?.pgtaSelectionChoice?.toLowerCase() == "pgta with mcp only" &&
                        tabValue == "3") ? (
                        <Card className="p-4 mt-8" variant="outlined">
                          <CardContent className="remove-bottom-padding">
                            <Stack direction="row" justifyContent="space-between">
                              <Typography variant="body2">Program Selection</Typography>
                            </Stack>
                            <Divider className="h-divider" />
                            <Stack direction="row">
                              <FormControl>
                                <FormLabel>Select a PGT-A Analysis payment option:</FormLabel>
                                <RadioGroup name="pgtaQuestion" onChange={handleChangeRadio}>
                                  <Stack direction={{ xs: "column", sm: "row" }}>
                                    <FormControlLabel
                                      checked={isProceedWithoutPgta === false ? true : false}
                                      value="Yes"
                                      control={<Radio />}
                                      label="PGT-A Analysis Unlimited Program that offers bundled savings and includes all PGT-A testing until a live birth occurs"
                                      disabled={
                                        practiceDatas?.pgtaSelectionChoice?.toLowerCase() ==
                                          "pgta with mcp only" &&
                                        programNameWithNumber === "Pay Per Cycle"
                                      }
                                    />
                                    <FormControlLabel
                                      checked={
                                        isProceedWithoutPgta === true ||
                                        (practiceDatas?.pgtaSelectionChoice?.toLowerCase() ==
                                          "pgta with mcp only" &&
                                          programNameWithNumber === "Pay Per Cycle")
                                          ? true
                                          : false
                                      }
                                      value="No"
                                      control={<Radio />}
                                      label="I do not want to bundle the cost of PGT-A.  I will pay the genetic lab directly per embryo tested."
                                    />
                                  </Stack>
                                </RadioGroup>
                              </FormControl>
                            </Stack>
                          </CardContent>
                        </Card>
                      ) : null}
                      <Card className="p-4 mt-8" variant="outlined">
                        <CardContent className="remove-bottom-padding">
                          <Stack direction="row" justifyContent="space-between">
                            <Typography variant="body2">Cost</Typography>
                          </Stack>
                          <Divider className="h-divider" />
                          <Grid container>
                            <Grid item xs={10} sm={8} md={6}>
                              <Stack>
                                <InputLabel>Services</InputLabel>
                                <Typography variant="body2">{data.treatmentPlanName}</Typography>
                              </Stack>
                            </Grid>
                            <Grid item xs={2} sm={4} md={6}>
                              <Stack>
                                <InputLabel>Cost</InputLabel>
                                <Typography variant="body2">
                                  ${data.originalTpPrice.toLocaleString()}
                                </Typography>
                              </Stack>
                            </Grid>
                          </Grid>

                          <Stack className="mt-8 ">
                            {stages.length && data?.treatmentType == "PGT-A Analysis"
                              ? stages.map((item, index) => {
                                  return <Typography key={index}>{item.stageName}</Typography>;
                                })
                              : null}
                          </Stack>
                          {adjustmentList.length &&
                          data &&
                          data.treatmentType == "PGT-A Analysis" ? (
                            <>
                              <Stack py={1}>
                                <Typography variant="body2">Adjustments</Typography>
                              </Stack>
                              {adjustmentList.map((item, i) => {
                                return (
                                  <Grid container key={i}>
                                    <Grid item xs={10} sm={8} md={6}>
                                      <Stack>
                                        <Typography>{item.type} Discount</Typography>
                                      </Stack>
                                    </Grid>
                                    <Grid item xs={2} sm={4} md={6}>
                                      <Stack width="100px" justifyContent="end">
                                        <Typography>
                                          {item.category === "G" || item.category === "LI"
                                            ? item.amountType == "A"
                                              ? ` - $${item.amount.toLocaleString()}`
                                              : ` - $${(
                                                  (item.amount / 100) *
                                                  data.originalTpPrice
                                                ).toLocaleString()}`
                                            : `+ $${item.amount.toLocaleString()}`}
                                        </Typography>
                                      </Stack>
                                    </Grid>
                                  </Grid>
                                );
                              })}
                            </>
                          ) : null}

                          <Grid container className="add-to-practice">
                            <Grid item xs={10} sm={8} md={6}>
                              <Typography variant="body2">
                                {data?.treatmentType === "PGT-A Analysis"
                                  ? "Total Cost of Program"
                                  : "Amount Due to Practice"}
                              </Typography>
                            </Grid>
                            <Grid item xs={2} sm={4} md={6}>
                              <Typography variant="body2">
                                {data && data.treatmentType === "PGT-A Analysis"
                                  ? "$" + data.originalTpPrice.toLocaleString()
                                  : "$" + data.tpPrice.toLocaleString()}
                                {/* ${data.tpPrice.toLocaleString()} */}
                              </Typography>
                            </Grid>
                          </Grid>
                          <Box className="mt-8">
                            <Typography variant="body2">Not Included But Necessary</Typography>
                            {necessary.length && data?.treatmentType != "PGT-A Analysis" ? (
                              <StageServiceItemList data={necessary} />
                            ) : null}
                          </Box>
                          <Divider className="mt-8" />
                          <Grid container className="add-to-practice">
                            <Grid item xs={10} sm={8} md={6}>
                              <Typography variant="body2">Total Estimated Costs*</Typography>
                              <Typography variant="caption">
                                (Reflects only necessary services and includes costs due outside of
                                the practice)
                              </Typography>
                            </Grid>
                            <Grid item xs={2} sm={4} md={6}>
                              {tabValue == "1" ? (
                                <Typography variant="body2">
                                  ${totalEstimate && totalEstimate.toLocaleString()}
                                  {necessary?.some((item) => item.tpStage.range === true) > 0
                                    ? " - $" +
                                      (totalEstimateMax ? totalEstimateMax.toLocaleString() : "")
                                    : ""}
                                </Typography>
                              ) : (
                                <Typography>${data.tpPrice.toLocaleString()}</Typography>
                              )}
                            </Grid>
                          </Grid>

                          <Box className="p-4 mt-8">
                            <Typography variant="body2">
                              Not Included But May Become Necessary
                            </Typography>
                            {optional.length && <StageServiceItemList data={optional} />}
                          </Box>
                        </CardContent>
                      </Card>
                    </>
                  )}
                </TabPanel>
              </TabContext>
            </Box>
          ) : null}
          {isFapView &
            (data?.treatmentType?.toString().toLowerCase().includes("ivf") ||
              data?.treatmentType?.toString().toLowerCase().includes("fp")) &&
          fapList &&
          fapList.programVisualization &&
          fapList.programVisualization.length > 0 ? (
            fapLoading ? (
              <Stack justifyContent="center" p={5} alignItems="center">
                <CircularProgress size={50} />
              </Stack>
            ) : (
              <FapView
                handleProgramSelect={handleProgramSelect}
                // getProgramId={getProgramId}
                practiceData={practiceInfoData}
                setBoxName={boxName}
                clearBox={clearBox}
                cardData={data}
                profileData={profileData}
              />
            )
          ) : null}
          {console.log(
            "==>",
            showCardDetails,
            tabValue,
            fapList?.programVisualization?.length,
            data?.mcpShowEstimate
          )}
          {showCardDetails &&
            (tabValue === "2" ||
              tabValue === "3" ||
              fapList?.programVisualization?.length <= 0 ||
              (!data?.mcpShowEstimate &&
                !data?.treatmentType?.toString().toLowerCase().includes("ivf"))) && (
              <Stack
                direction="row"
                gap={1}
                className="mr-8 m-t-10"
                alignItems="center"
                justifyContent="flex-end">
                <Button variant="outlined" onClick={handleCancelClick}>
                  Cancel
                </Button>

                {practiceData?.selectionChoice === "Voluntary" && tabValue === "2" && (
                  <Button variant="contained" onClick={handlePgtaClick}>
                    Proceed Without PGT-A
                  </Button>
                )}

                <Button
                  variant="contained"
                  onClick={handleSelectAndProceed}
                  disabled={disableSelectBtn()}>
                  Select And Proceed
                </Button>
              </Stack>
            )}
        </>
      )}

      {/* {console.log("openConfirmPage", openConfirmPage)} */}
      {/* {openConfirmPage === true ? <ConfirmSelection /> : null} */}
      {showFPProgramApplication(data) ? (
        <NextSteps practiceInfo={practiceInfoData} estimatePublishdate={caseList?.publishedDate} />
      ) : null}

      {/* {console.log('@@@@ caseList', caseList)} */}
      {/* refund popup */}
      {refundOptionModal ? (
        <Modal open={refundOptionModal} backdrop="static" aria-labelledby="modal-add-title">
          <Box className="refund-option-modal">
            <Stack direction="row" className="modal-stack">
              <Typography>PROCEED WITHOUT REFUND OPTION CONFIRMATION</Typography>
              <IconButton onClick={() => setRefundOptionModal(false)}>
                <img alt="" src="/Assets/close.png" />
              </IconButton>
            </Stack>
            <Divider className="modal-divider" />
            <Stack direction="column" py={2}>
              <Typography>
                You may still be eligible for a refund when you receive your application decesion.
                Are you sure you want to continue without a refund application? If you do not bring
                home a baby, you will not receive a refund.
              </Typography>
              <FormControlLabel
                value="start"
                control={
                  <Checkbox
                    color="primary"
                    value={refundCheck}
                    checked={refundCheck}
                    onChange={(e) => setRefundCheck(e.target.checked)}
                  />
                }
                label="I do not want a refund option if I become eligible"
                labelPlacement="end"
              />
              <Typography>
                Please contact a Fertility Access Concierge at
                <span className="theme-color"> 1-800-873-9203</span>
              </Typography>
            </Stack>
            <Stack direction="row" gap={1} className="align-end">
              <Button
                variant="outlined"
                onClick={() => {
                  setRefundOptionModal(false);
                }}>
                Cancel
              </Button>
              <Button
                variant="contained"
                disabled={!refundCheck}
                onClick={() => {
                  setRefundOptionModal(false);
                  setConfirmModal(true);
                }}>
                Continue
              </Button>
            </Stack>
          </Box>
        </Modal>
      ) : null}

      {/* confirm popup */}
      {confirmModal ? (
        <Modal open={confirmModal} backdrop="static" aria-labelledby="modal-add-title">
          <Box className="alert-modal">
            <Stack direction="row" className="modal-stack">
              {/* <Typography>Proceed Without Refund Option Confirmation</Typography> */}
              <Typography>CONFIRM YOUR SELECTION</Typography>
              <IconButton onClick={() => setConfirmModal(false)}>
                <img alt="" src="/Assets/close.png" />
              </IconButton>
            </Stack>
            <Divider className="modal-divider" />
            <Box>
              <Typography my={2}>
                Should you choose to change your selection after this confirmation, please call us
                at{" "}
                <span className="primary-one">
                  {(practiceInfoData &&
                    practiceInfoData.phoneNumber &&
                    toUSAFormat(practiceInfoData.phoneNumber)) ||
                    ""}
                </span>
              </Typography>

              <Stack direction="row" py={1} justifyContent="space-between">
                <Stack direction="column" mx={1} mb={1}>
                  <InputLabel sx={{ fontSize: 11 }}>Treatment Plan:</InputLabel>

                  <Typography>{selectedCard.treatmentPlanName}</Typography>
                  {selectedCard.linkedEstimateTreatmentPlan != null && !isProceedWithoutPgta ? (
                    <Typography>
                      {selectedCard?.linkedEstimateTreatmentPlan.treatmentPlanName}
                    </Typography>
                  ) : (
                    ""
                  )}
                </Stack>
                <Stack direction="column" mx={1} alignItems="end"></Stack>
              </Stack>
              {/* {selectedCard.linkedEstimateTreatmentPlan != null && !isProceedWithoutPgta ? (
                <Stack direction="row" py={1} justifyContent="space-between">
                  <Stack direction="column" mx={1} mb={1}>
                    <InputLabel sx={{ fontSize: 11 }}>Treatment Plan:</InputLabel>
                    <Typography>
                      {selectedCard?.linkedEstimateTreatmentPlan.treatmentPlanName}
                    </Typography>
                  </Stack>
                  <Stack direction="column" mx={1} alignItems="end"></Stack>
                </Stack>
              ) : (
                ""
              )} */}
              <Stack direction="row" className="total-cost" justifyContent="space-between">
                <Stack direction="column" mx={1} mb={1}>
                  <InputLabel sx={{ fontSize: 11 }}>Payment option selected</InputLabel>
                  <Typography style={{ marginTop: "3px" }}>
                    {selectedCard?.treatmentType === "IVF" || selectedCard?.treatmentType === "FP"
                      ? (programNameWithNumber && programNameWithNumber) || "--"
                      : selectedCard?.treatmentType === "PGT-A Analysis"
                      ? isProceedWithoutPgta === true ||
                        (practiceDatas?.pgtaSelectionChoice?.toLowerCase() ==
                          "pgta with mcp only" &&
                          programNameWithNumber === "Pay Per Cycle")
                        ? "Pay Genetic Lab Directly"
                        : selectedCard?.linkProgram
                      : ""}
                  </Typography>

                  {selectedCard?.linkedEstimateTreatmentPlan != null && !isProceedWithoutPgta ? (
                    <Typography style={{ marginTop: "3px" }}>
                      {/* {selectedCard?.linkedEstimateTreatmentPlan?.treatmentPlanName || ""} */}
                      {selectedCard?.linkProgram || ""}
                    </Typography>
                  ) : null}
                </Stack>
                <Stack direction="column" mx={1} alignItems="end">
                  <InputLabel sx={{ fontSize: "11px" }}>Cost</InputLabel>
                  {selectedCard?.linkedEstimateTreatmentPlan != null && (
                    <>
                      <Typography style={{ marginTop: "3px" }}>
                        ${selectedProgramPrice.toLocaleString()}
                      </Typography>
                      {!isProceedWithoutPgta ? (
                        <Typography style={{ marginTop: "3px" }}>
                          $
                          {(
                            selectedCard?.linkedEstimateTreatmentPlan?.tpPrice || ""
                          ).toLocaleString()}
                        </Typography>
                      ) : null}
                    </>
                  )}

                  {selectedCard.treatmentType.indexOf("IVF") == -1 &&
                    selectedCard.treatmentType !== "FP" &&
                    selectedCard.treatmentType !== "FET" &&
                    selectedCard.treatmentType !== "PGT-A Analysis" && (
                      <Typography style={{ marginTop: "3px" }}>
                        ${totalEstimate && totalEstimate.toLocaleString()}
                      </Typography>
                    )}
                  {selectedCard.treatmentType === "FET" && (
                    <Typography style={{ marginTop: "3px" }}>
                      ${(selectedCard?.tpPrice || "").toLocaleString()}
                    </Typography>
                  )}
                  {tabValue != "3" && selectedCard.treatmentType === "PGT-A Analysis" && (
                    <Typography style={{ marginTop: "3px" }}>
                      ${(selectedCard?.tpPrice || "").toLocaleString()}
                    </Typography>
                  )}
                  {tabValue == "3" && selectedCard.treatmentType === "PGT-A Analysis" && (
                    <Typography style={{ marginTop: "3px" }}>
                      {!isProceedWithoutPgta ? "$" : ""}
                      {isProceedWithoutPgta
                        ? "Varies By Lab"
                        : (selectedCard?.tpPrice || "").toLocaleString()}
                    </Typography>
                  )}
                  {selectedCard.treatmentType === "FP" && (
                    <Typography style={{ marginTop: "3px" }}>
                      {/* ${(selectedCard?.tpPrice || "").toLocaleString()} */}$
                      {selectedProgramPrice.toLocaleString()}
                    </Typography>
                  )}
                  {selectedCard.treatmentType.toString().toLowerCase().includes("ivf") &&
                    selectedCard?.linkedEstimateTreatmentPlan == null && (
                      <Typography style={{ marginTop: "3px" }}>
                        ${selectedProgramPrice.toLocaleString()}
                      </Typography>
                    )}
                </Stack>
              </Stack>
            </Box>
            <Stack direction="row" gap={1} mt={3} className="align-right">
              <Button variant="outlined" onClick={() => setConfirmModal(false)}>
                Cancel
              </Button>
              <Button variant="contained" onClick={handleConfirm}>
                Confirm
              </Button>
            </Stack>
          </Box>
        </Modal>
      ) : null}

      {/* confirm popup */}
      {programLoading ? (
        <Modal open={programLoading} backdrop="static" aria-labelledby="modal-add-title">
          <Box className="alert-modal" width="100px">
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}>
              <CircularProgress size={50} />
            </Box>
          </Box>
        </Modal>
      ) : null}

      {isMessageModal ? (
        <MessageModal
          open={isMessageModal}
          message={programSuccess}
          error={programError}
          closeModal={closeMessageModal}
        />
      ) : null}
    </Box>
  );
};
const mapStateToProps = ({ homeReducer, estimateReducer, profileReducer }) => {
  return {
    estimateCards: estimateReducer.estimateCards,
    loading: estimateReducer.estimateCardLoading,
    stageLoading: estimateReducer.stageLoading,
    necessaryLoading: estimateReducer.necessaryLoading,
    adjustmentLoading: estimateReducer.adjustmentLoading,
    optionalLoading: estimateReducer.optionalLoading,
    stages: estimateReducer.stages,
    // notes: estimateReducer.notes,
    necessary: estimateReducer.necessary,
    practiceDatas: homeReducer.practiceData,

    optional: estimateReducer.optional,
    adjustmentList: estimateReducer.adjustmentList,
    fapLoading: estimateReducer.fapLoading,
    practiceData: estimateReducer.practiceData,
    programLoading: estimateReducer.programLoading,
    programSelection: estimateReducer.programSelection,
    programSuccess: estimateReducer.programSuccess,
    programError: estimateReducer.programError,
    profileData: profileReducer.profileData,
    fapList: estimateReducer.fapList,
    practiceInfoData: profileReducer.practiceInfoData,
    estimateCardLoading: estimateReducer.estimateCardLoading
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: {
    getStages: (payload) => {
      dispatch(actionType.getStages(payload));
    },
    getPracticeData: (payload) => {
      dispatch(actionType.getPracticeData(payload));
    },
    getAdjustments: (payload) => {
      dispatch(actionType.getAdjustments(payload));
    },
    getNecessary: (payload) => {
      dispatch(actionType.getNecessary(payload));
    },
    getOptional: (payload) => {
      dispatch(actionType.getOptional(payload));
    },
    resetCostCoverage: () => {
      dispatch(actionType.resetCostCoverage());
    },
    getFertilityAccessPrograms: (payload) => {
      dispatch(actionType.getFertilityAccessPrograms(payload));
    },
    getPracticePGTAData: (payload) => {
      dispatch(actionType.getPracticePGTAData(payload));
    },
    updateProgramSelections: (payload) => {
      dispatch(actionType.updateProgramSelections(payload));
    },
    reviewEstimate: (payload) => {
      dispatch(actionType.reviewEstimate(payload));
    },
    resetEstimateCards: () => {
      dispatch(actionType.resetEstimateCards());
    },
    getEstimateCard: (payload) => {
      dispatch(actionType.getEstimateCard(payload));
    },
    getCaseStatusesData: (payload) => {
      dispatch(actionType.getCaseStatusesData(payload));
    },
    resetCaseStatus: () => {
      dispatch(actionType.resetCaseStatus());
    },
    resetMsgs: () => {
      dispatch(actionType.resetMsgs());
    },
    getProfileData: (payload) => {
      dispatch(actionType.getProfileData(payload));
    },
    getPracticeInfoData: (payload) => {
      dispatch(actionType.getPracticeInfoData(payload));
    }
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(EstimateCards);
